import send from "./send_icon_16px.png";

export const SendIcon = () => <img src={send} alt="Send icon" />;
